import { benefitUseResource, BenefitUseResource } from '@witkac/kartamiejska-resources';
import { BenefitUse } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł historii
 *
 * @export
 * @class BenefitsHistoryModule
 * @extends {EntityModule<BenefitUse, BenefitUseResource>}
 */
export class BenefitsHistoryModule extends EntityModule<BenefitUse, BenefitUseResource> {
  constructor() {
    super(benefitUseResource);
  }
}

export default new BenefitsHistoryModule();
